var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimbolodesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 256,
    viewBox: "0 0 73 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.62749e-06 218.767L-3.01609e-06 187L73 223.891L73 256L-1.62749e-06 218.767Z",
    fill: "#15205A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.58032e-06 144.847L-2.92866e-06 114L73 149.822L73 181L-1.58032e-06 144.847Z",
    fill: "#15205A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.65108e-06 69.2277L-3.0598e-06 37L73 74.4257L73 107L-1.65108e-06 69.2277Z",
    fill: "#15205A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65108e-06 186.772L3.0598e-06 219L73 181.574L73 149L1.65108e-06 186.772Z",
    fill: "#4172C7",
    fillOpacity: 0.85
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58032e-06 111.153L2.92866e-06 142L73 106.178L73 75L1.58032e-06 111.153Z",
    fill: "#4172C7",
    fillOpacity: 0.85
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62749e-06 37.2327L3.01609e-06 69L73 32.1089L73 -3.19093e-06L1.62749e-06 37.2327Z",
    fill: "#4172C7",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimbolodesktop);
export default __webpack_public_path__ + "static/media/simbolodesktop.5847952ae66c4a795e7b03f1a5a8a37b.svg";
export { ForwardRef as ReactComponent };